import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FiUsers, FiTrendingUp, FiBarChart2 } from 'react-icons/fi';
import AllHolders from './AllHolders';
import TopHolders from './TopHolders';
import HoldingsMovement from './HoldingsMovement';
import HolderDetail from './HolderDetail';

// url segment → tab; no segment = All holders. Holdings movement / Reports land here as they are built.
// Top holders badge is fixed: the provider report is capped at 50 positions
const tabs = [
    { path: '', label: 'All holders', icon: <FiUsers />, component: AllHolders },
    { path: 'top-holders', label: 'Top holders', icon: <FiTrendingUp />, component: TopHolders, badge: 50 },
    { path: 'holdings-movement', label: 'Holdings movement', icon: <FiBarChart2 />, component: HoldingsMovement },
];

const ShareRegistry: React.FC = () => {
    const history = useHistory();
    const { tab = '', id } = useParams<{ tab?: string; id?: string }>();
    // /share-registry/holder/{holderId} (or /holder/web?email=) opens a holder under the All holders tab
    const holder = tab === 'holder';
    const current = tabs.find(x => x.path === tab) ?? tabs[0];

    return <div className="v2-page share-registry-v2">
        <div className="sub-tabs">
            {tabs.map(x => <button key={x.path} type="button" className={x === current ? 'active' : ''}
                onClick={() => history.push(`/share-registry${x.path && `/${x.path}`}`)}>{x.icon} {x.label}{x.badge && <span className="badge">{x.badge}</span>}</button>)}
        </div>

        {/* each tab renders its own .page-header — subtitle and actions differ per tab */}
        {holder ? <HolderDetail key={id} holderId={id} /> : <current.component />}
    </div>;
};

export default ShareRegistry;
